export { default as SecondPanel } from './secondPanel';
